import React, { useState, useEffect } from 'react';
import { get } from './axios_call';
import ModelGallery from '../elements/model/ModelGallery';

export default (name, gallery, viewSize) => {
  const [images, setImages] = useState([]);
  const [sizes, setSizes] = useState('');
  const [names, setNames] = useState('');
  const [galleries, setGalleries] = useState([]);
  useEffect(() => {
    let sourceOuter;
    get(`representative/${gallery}/${name}`, false).then(([res, source]) => {
      sourceOuter = source;
      setNames(res.data.names);
      setSizes(res.data.sizes);
      setGalleries(res.data.galleries);
      setImages(
        gallery === 'biography'
          ? (
            res.data.gallery
          ) : (
            res.data.gallery.images.map((image) => (
              <ModelGallery image={image} key={image.high} id={image.id} viewSize={viewSize} />
            ))
          ),
      );
    });
    return () => {
      sourceOuter.cancel();
      setSizes('');
      setNames('');
      setImages([]);
    };
  }, [name, gallery, viewSize]);
  return [images, sizes, names, galleries];
};
